<template>
  <ClientOnly>
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-model="visible"
      class="join-dialog"
      destroy-on-close
      title="申请合作"
      width="560px">
      <div class="box">
        <!-- <div class="box_left">
          <div v-for="item in cooperateTypeList" class="left_context">
            <div
              @click="getType(item)"
              :style="
                item.value == checkId
                  ? 'color:  #E50113; background: #fff;'
                  : 'background: #f3f5f8; '
              "
            >
              {{ item.label }}
            </div>
          </div>
        </div> -->
        <div class="box_right">
          <el-form
            ref="formRef"
            :model="formObj"
            :rules="rules"
            label-position="right"
            label-width="40px">
            <el-form-item prop="cooperateType">
              <el-select
                v-model="formObj.cooperateType"
                class="fair-input"
                placeholder="请选择合作类型（必选）"
                style="width: 400px">
                <el-option
                  v-for="item in cooperateTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{ item.label }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="userType">
              <el-select
                v-model="formObj.userType"
                class="fair-input"
                placeholder="请选择公司类型（必选）"
                style="width: 400px">
                <el-option
                  v-for="item in userType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{ item.label }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="companyName">
              <el-input
                v-model="formObj.companyName"
                class="fair-input"
                clearable
                placeholder="请输入企业名称（必填）"
                style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item prop="contacts">
              <el-input
                v-model="formObj.contacts"
                class="fair-input"
                clearable
                placeholder="请输入联系姓名（必填）"
                style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input
                v-model="formObj.phone"
                class="fair-input"
                clearable
                placeholder="请输入联系手机（必填）"
                style="width: 400px"></el-input>
            </el-form-item>
            <template v-if="formObj.userType !== EUserType.展会服务商">
              <el-form-item
                v-for="(item, index) in formObj.cooperateExhibition"
                :key="item.key"
                :rules="{
                  required: true,
                  message: '请输入合作展会',
                  trigger: 'blur'
                }">
                <div class="fair-input row-flex ac">
                  <el-input
                    v-model="item.value"
                    clearable
                    placeholder="请输入合作展会"
                    style="width: 400px"></el-input>
                  <el-icon
                    :size="32"
                    color="#999">
                    <CirclePlus @click="addDomain" />
                  </el-icon>
                  <el-icon
                    :size="32"
                    color="#999">
                    <Remove
                      v-if="formObj.cooperateExhibition.length > 1"
                      @click.prevent="removeDomain(item)" />
                  </el-icon>
                </div>
              </el-form-item>
            </template>
            <el-form-item
              v-if="formObj.userType === EUserType.展会服务商"
              prop="cooperationContent">
              <el-select
                v-model="formObj.cooperationContent"
                multiple
                placeholder="请选择合作内容"
                style="width: 100%">
                <el-option
                  v-for="item in serverType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{ item.label }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="resetForm(formRef)">重 置</el-button>
          <el-button
            type="primary"
            @click="submit(formRef)">
            确 定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </ClientOnly>
</template>

<script lang="ts">
  import { computed, defineComponent, inject, onMounted, ref, watch } from 'vue'
  import { ElForm, type FormInstance, type FormRules } from 'element-plus'
  import { ResponseCode } from '~/utils/constant'
  import { CirclePlus, Remove } from '@element-plus/icons-vue'
  import type Login from '~/components/Login/index.vue'
  import { fetchCompanyCooperateSave } from '~/api/companyCooperate'

  enum EUserType {
    主办单位 = 1,
    展位代理公司 = 2,
    展会服务商 = 3
  }

  enum EServerType {
    机票 = 1,
    酒店 = 2,
    签证 = 3,
    搭建 = 4,
    地接 = 5,
    翻译 = 6,
    其他 = 0
  }

  interface IForm {
    cooperateType?: number
    userType: number | undefined
    companyName: string
    contacts: string
    phone: string
    cooperateExhibition: { key: number; value: string }[]
    cooperationContent: number[]
  }

  export default defineComponent({
    components: { Remove, CirclePlus },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    setup(props, { emit }) {
      // 使用 inject 方法，接收弹窗的模板引用，同时使用类型断言 as 设置它的类型
      const loginModal = inject<typeof Login>('loginModal')

      const globalStore = useGlobalStore()
      const formRef = ref(null)
      const formObj = ref<IForm>({
        userType: undefined,
        companyName: '',
        contacts: '',
        phone: '',
        cooperateType: undefined,
        cooperateExhibition: [
          {
            key: 1,
            value: ''
          }
        ],
        cooperationContent: []
      })
      const rules = ref<FormRules<IForm>>({
        cooperateType: [{ required: true, message: '请选择合作类型', trigger: 'blur' }],
        userType: [{ required: true, message: '请选择企业类型', trigger: 'blur' }],
        companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        contacts: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          {
            pattern: /^[^\d]*$/,
            message: '请输入正确的联系人姓名',
            trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: '请输入联系人手机', trigger: 'blur' },
          {
            pattern: /^[0-9]*$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        cooperationContent: [
          {
            required: true,
            message: '请选择需要合作的服务内容',
            trigger: 'change'
          }
        ]
      })
      const cooperateTypeList = ref([
        { value: 0, label: '展位代理合作', check: false },
        { value: 1, label: '展位搭建合作', check: false },
        { value: 2, label: '签证办理合作', check: false },
        { value: 3, label: '机票代理合作', check: false },
        { value: 4, label: '展会地接合作', check: false },
        { value: 5, label: '展具租赁合作', check: false },
        { value: 6, label: '展会补贴合作', check: false },
        { value: 7, label: '观众招募合作', check: false },
        { value: 8, label: '广告投放合作', check: false }
      ])
      const cooperateType = ref(0)
      const checkId = ref(0)

      const userType = computed<any[]>(() => {
        return Object.keys(EUserType)
          .map(k => {
            if (!/^\d+$/.test(k)) {
              return {
                label: k,
                value: EUserType[k as keyof typeof EUserType]
              }
            }
          })
          .filter(e => !!e)
      })

      const serverType = computed<any[]>(() => {
        return Object.keys(EServerType)
          .map(k => {
            if (!/^\d+$/.test(k)) {
              return {
                label: k,
                value: EServerType[k as keyof typeof EServerType]
              }
            }
          })
          .filter(e => !!e)
      })

      watch(
        () => globalStore.isLogin,
        val => {
          if (val) {
            formObj.value.phone = globalStore.user.userName || ''
            formObj.value.companyName = globalStore.user.companyName || ''
          }
        }
      )

      onMounted(() => {
        if (globalStore.isLogin) {
          formObj.value.phone = globalStore.user.userName || ''
          formObj.value.companyName = globalStore.user.companyName || ''
        }
      })

      const handleClose = () => {
        emit('close')
      }

      const getType = (data: any) => {
        data.check = !data.check
        cooperateType.value = data.value
        checkId.value = data.value
      }

      const addDomain = () => {
        formObj.value.cooperateExhibition.push({
          value: '',
          key: Date.now()
        })
      }

      const removeDomain = (data: any) => {
        formObj.value.cooperateExhibition = formObj.value.cooperateExhibition.filter(
          item => item.key !== data.key
        )
      }

      const fetchSave = async () => {
        const params = {
          cooperateType: formObj.value.cooperateType,
          ...formObj.value,
          cooperateExhibition:
            formObj.value.cooperateExhibition.length > 0
              ? formObj.value.cooperateExhibition.map(item => item.value).toString()
              : undefined,
          cooperationContent:
            formObj.value.cooperationContent.length > 0
              ? formObj.value.cooperationContent.toString()
              : undefined,
          promotionLink: window.location.href
        }
        if (params.userType === EUserType.展会服务商) {
          delete params.cooperateExhibition
        } else {
          delete params.cooperationContent
        }
        const res = await fetchCompanyCooperateSave(params)
        if (res?.code === ResponseCode.SUCCESS) {
          handleClose()
        }
      }

      const resetForm = (formEl: FormInstance | null) => {
        formEl?.resetFields()
      }

      const submit = (formEl: FormInstance | null) => {
        if (!globalStore.isLogin) {
          return loginModal?.value.open()
        }
        formEl?.validate(valid => {
          if (valid) {
            fetchSave()
          }
        })
      }

      return {
        formRef,
        formObj,
        rules,
        cooperateTypeList,
        cooperateType,
        checkId,
        userType,
        serverType,
        EUserType,
        EServerType,
        handleClose,
        getType,
        addDomain,
        removeDomain,
        fetchSave,
        resetForm,
        submit
      }
    }
  })
</script>

<style lang="less" scoped>
  .join-dialog {
    :deep(.el-tag.el-tag--info .el-tag__close) {
      color: #fff;
    }

    .box {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      // text-align: center;
      // padding-left: 60px;
      .box_left {
        width: 30%;

        .left_context {
          > div {
            text-align: center;
            padding: 20px;
            font-size: 20px;
            border: 1px solid #f3f5f8;
            margin: 8px;
          }
        }
      }

      .box_right {
        // margin-left: 80px;
        :deep(.el-input__inner) {
          height: 55px;
        }

        .fair-input {
          :deep([class^='el-icon-']) {
            font-size: 32px;
            color: #999;
            position: relative;
            top: 6px;

            &:hover {
              color: #f00000;
            }
          }
        }
      }
    }

    .dialog-footer {
      :deep(.el-button) {
        padding: 12px 40px;
      }
    }
  }
</style>
